import {api} from "@/services/Api";

export interface CoreStore {
    autoCertificates: any[],

}

const state: CoreStore = {
    autoCertificates: [],
}

const mutations = {

}

const actions = {

}

const getters = {
    // isLoggedIn: (state: ComparatorStore) => !!state.user
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
